<p-tabView [(activeIndex)]="index" (onChange)="getIndex($event)" [class.fixed]="navFixed" class="scroll-bar">
    <p-tabPanel header="Payment Terms">
        @if(index==0){
        <app-paymentterm [index]="index" [displayPaymentTermAdd]="displayPaymentTermAdd"
         (closeDialog)="closePaymentTerm()"></app-paymentterm>
        }
    </p-tabPanel>
    <p-tabPanel header="Payment Methods">
        @if(index==1){
        <app-paymentmethod  [index]="index" [displayPaymentMethodAdd]="displayPaymentMethodAdd"
         (closeDialog)="closePaymentMethod()"></app-paymentmethod>
        }
    </p-tabPanel>
    <p-tabPanel header="Vendor Payment Terms">
        @if(index==2){
        <app-paymentterm [index]="index" [displayPaymentTermAdd]="displayPaymentTermAdd"
         (closeDialog)="closePaymentTerm()"></app-paymentterm>
        }
    </p-tabPanel>
    <p-tabPanel header="Vendor Payment Methods">
        @if(index==3){
        <app-paymentmethod  [index]="index" [displayPaymentMethodAdd]="displayPaymentMethodAdd"
        (closeDialog)="closePaymentMethod()"></app-paymentmethod>
        }
    </p-tabPanel>
    <p-tabPanel header="Shipping Carrier">
        <app-shippingmethod [financialAccounts]="financialAccounts"></app-shippingmethod>
    </p-tabPanel>
    <p-tabPanel header="Shipping Terms">
        <app-shippingterm></app-shippingterm>
    </p-tabPanel>
    <p-tabPanel header="FOB Point">
        <app-fobpoint [financialAccounts]="financialAccounts"></app-fobpoint>
    </p-tabPanel>
    <p-tabPanel header="Discount" *ngIf="inventorygrps.length>0">
        <app-discount [groups]="inventorygrps" [discountBy]="discountTypes" [financialAccounts]="financialAccounts" [baseCurrency]="baseCurrency"></app-discount>
    </p-tabPanel>
    <p-tabPanel header="Additional Fees" *ngIf="inventorygrps.length>0">
        <app-additionlfees [groups]="inventorygrps" [discountBy]="discountTypes" [financialAccounts]="financialAccounts" [baseCurrency]="baseCurrency"></app-additionlfees>
    </p-tabPanel>
    <p-tabPanel header="Tax Rate" *ngIf="inventorygrps.length>0">
        <app-taxrate [rateTypes]="discountTypes" [financialAccounts]="financialAccounts"></app-taxrate>
    </p-tabPanel>
    <p-tabPanel header="Order Source" *ngIf="inventorygrps.length>0">
        <app-ordersource [groups]="inventorygrps"></app-ordersource>
    </p-tabPanel>
    <p-tabPanel header="UOM">
        <app-uom1></app-uom1>
    </p-tabPanel>
    <p-tabPanel header="Pack Boxes">
        <app-pack-box></app-pack-box>
    </p-tabPanel>
    <p-tabPanel [disabled]="true" headerStyleClass="iconPanel">
        <ng-template pTemplate="header">
            <p-menu #configmenuSetup id="config_menu_setup" [model]="configMenuSetupItems" [popup]="true"
                appendTo="body" [baseZIndex]="1">
            </p-menu>
            <span class="btnBars" (click)="configmenuSetup.toggle($event)">
                <i class="pi pi-bars"></i>
            </span>
        </ng-template>
    </p-tabPanel>
</p-tabView>